import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, Legend, Title, Tooltip } from 'chart.js';

ChartJS.register(Legend, Title, Tooltip);

const DonutGraph = React.forwardRef((props, ref) => {
    const options = {
        maintainAspectRatio: true,
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
            },
            title: {
                display: true,
                text: props.text,
            },
        },
    };

    return <Doughnut ref={ref} data={props.data} options={options} />;
});

export default DonutGraph;
